// extracted by mini-css-extract-plugin
module.exports = {"bg":"styles_bg__3ks20","default":"styles_default__x9zYi","simple":"styles_simple__2wT2i","omitXs":"styles_omitXs__3_j8u"};